const CERTIFICATION_NUMBER_LENGTH = 16;

type FunifierDateValue = number | { $date: string } | null | undefined;

interface CertificationNumberDates {
  approvedDate?: FunifierDateValue;
  quizFinished?: FunifierDateValue;
  finished?: FunifierDateValue;
}

/**
 * O Funifier devolve data como epoch em ms (projeções de aggregate) ou como
 * `{ $date }`. Devolve `null` quando não há data utilizável.
 */
function toEpochMs(value: FunifierDateValue): number | null {
  if (typeof value === 'number') return Number.isFinite(value) ? value : null;
  if (!value?.$date) return null;

  const epochMs = new Date(value.$date).getTime();
  return Number.isNaN(epochMs) ? null : epochMs;
}

/**
 * Número do certificado — mesma regra do Relatório CRCP do Studio:
 * `approved_date` em ms com zeros à esquerda até 16 dígitos. Sem ele, usa o
 * fim da prova (`quiz_log.finished`), depois o `finished` do log; sem nenhuma
 * data, 16 zeros.
 */
export function resolveCertificationNumber({
  approvedDate,
  quizFinished,
  finished,
}: CertificationNumberDates): string {
  const epochMs =
    toEpochMs(approvedDate) ?? toEpochMs(quizFinished) ?? toEpochMs(finished);

  return String(epochMs ?? 0).padStart(CERTIFICATION_NUMBER_LENGTH, '0');
}
